import axios from "axios";

export function startAudit(audit_code, session_id) {
    return new Promise((resolve, reject) => {
        const url = `/api/audit/start/${audit_code}`;
        axios
            .post(url, { session_id: session_id })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function endAudit(session_id) {
    return new Promise((resolve, reject) => {
        const url = `/api/audit/end/${session_id}`;
        axios
            .patch(url)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
